export default class AuctionTimer{

    constructor(item, cb) {
        this.timer = 0;
        this.ts = 0;
        this.seconds = 0;
        this.item = item
        this.ended = false;
        this.cb = ()=>{};
        this.startTimer = this.startTimer.bind(this);
        this.onTimerChange = this.onTimerChange.bind(this);
    }


    secondsToTime(secs){
        let hours = Math.floor(secs / (60 * 60));
        
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);
        
        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);                        
        
        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    
    startTimer(tcb){
        this.cb = tcb;
        this.onTimerChange()
        this.timer = setInterval(this.onTimerChange, 1000);
    }

    destoryTimer(){
        clearInterval(this.timer);
    }
    
    getAuctionState(){ 
        if(this.item.minted) {
            this.ts = new Date(this.item.mintedAt).getTime()/1000;
            this.ended = true;
        }
        else {
            this.ts = new Date(this.item.auctionEndingAt).getTime()/1000;
        }
        var now = new Date().getTime()/1000;
        if(!this.ended && (now < this.ts)){
            this.seconds = this.ts - now;
            this.ended = false
        }
        else {
            this.seconds = now - this.ts;
            this.ended = true
        }
        this.timer = 0;
    }
    
    shouldTimerChange(){
        this.getAuctionState()
        if (this.timer == 0 && this.seconds > 0) {
            return true;
        }
        return false;
    }
        
    onTimerChange(){
        let seconds = this.seconds - 1;
        // Check if we're at zero.
        if (seconds == 0 || seconds < 0) {
            this.time = this.secondsToTime(0);
            this.seconds = 0;
            this.cb(this.time, this.seconds);
            clearInterval(this.timer);
        }
        else{
            this.time = this.secondsToTime(seconds)
            this.seconds = seconds;
            this.cb(this.time, this.seconds);
        }
    }
    
}
